import { BaseIcon } from './BaseIcon';

const DiamondIcon = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        d="M21 10H3M10.5 5L9 10L12 20L15 10L13.5 5M3.53192 10.591L11.2567 19.1741C11.6539 19.6155 12.3461 19.6155 12.7433 19.1741L20.4681 10.591C20.7795 10.245 20.811 9.72994 20.544 9.3486L17.7986 5.42654C17.6114 5.15921 17.3057 5 16.9793 5H7.02066C6.69434 5 6.38855 5.15921 6.20142 5.42654L3.45598 9.3486C3.18905 9.72994 3.22053 10.245 3.53192 10.591Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

export default DiamondIcon;
